import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Clearfix, Alert } from 'react-bootstrap';

import FabActions from 'components/layout/FabActions';
import FabActionElement from 'components/layout/FabActionElement';

import ClientActions from 'components/layout/client/ClientActions';

class ClientInfos extends React.Component {
  constructor(props) {
    super(props);

    const { inModal } = props;

    this.state = {
      compact: inModal,
    };
  }

  showDetails = e => {
    e.preventDefault();

    this.setState({ compact: false });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      showActions,
      addEditAction,
      entity,
      history,
      inModal,
    } = this.props;
    const { compact } = this.state;

    const addActions = [];
    if (addEditAction) {
      addActions.push(
        <FabActionElement
          size="60"
          icon="fas fa-pencil-alt"
          caption={messages.client_account}
          action={() => history.push(appIntl.urlPrefix + 'account/clients/' + entity.getUsername())}
        />
      );
    }

    const addressSet = !!entity.getProfile().getStreet() && !!entity.getProfile().getCity();
    const clientName = (
      <>
        {!!entity.getProfile().getCompany() && (
          <span>
            <strong>{entity.getProfile().getCompany()}</strong>
            <br />
          </span>
        )}
        {entity.getProfile().getFirstName()} {entity.getProfile().getLastName()}
      </>
    );

    return (
      <Clearfix>
        {inModal && compact && (
          <a href="#showDetails" className="block clearfix text-master" onClick={this.showDetails}>
            <span className="pull-left block">
              <i className="fal fa-chevron-down" />
            </span>
            <span className="block m-l-25">{clientName}</span>
          </a>
        )}

        {(!inModal || !compact) && (
          <>
            <dl className="no-margin full-width">
              <dt>{messages.client_name}</dt>
              <dd>{clientName}</dd>

              {addressSet ? (
                <>
                  <dt className="m-t-5">{messages.address}</dt>
                  <dd>
                    {entity.getProfile().getStreet()} {entity.getProfile().getHouseNumber()}{' '}
                    {entity.getProfile().getApartmentNumber()}
                    <br />
                    {entity.getProfile().getZipCode()} {entity.getProfile().getCity()}
                    <br />
                    {entity.getProfile().getCountryName()}
                  </dd>
                </>
              ) : (
                <Alert bsStyle="info">{messages.address_not_set}</Alert>
              )}
            </dl>

            {!!entity.getProfile().getEmail() && (
              <div className="m-t-5">
                <i className="fa fa-envelope fa-fw" /> {entity.getProfile().getEmail()}
              </div>
            )}

            {!!entity.getProfile().getPhone() && (
              <div className="m-t-5">
                <i className="fa fa-phone fa-fw" /> {entity.getProfile().getPhone()}
              </div>
            )}

            {!!entity.getProfile().getMobile() && (
              <div className="m-t-5">
                <i className="far fa-mobile-android fa-fw" /> {entity.getProfile().getMobile()}
              </div>
            )}
          </>
        )}

        {showActions && (
          <div className="top-right m-t-20" style={{ marginLeft: '-70px' }}>
            <FabActions>
              <ClientActions
                client={entity.processedData ? entity.processedData : entity}
                wrapperComponent={null}
                listItemComponent={<FabActionElement size="60" />}
                addActions={addActions}
              />
            </FabActions>
          </div>
        )}
      </Clearfix>
    );
  }
}
ClientInfos.defaultProps = {
  showActions: true,
  addEditAction: false,
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(ClientInfos)));
